import { BreakpointObserver } from '@angular/cdk/layout';
import { ButtonCustomSizeConfig } from 'nanaykuna-ui-kit/loader';
import { map, Observable } from 'rxjs';

/** Breakpoint where the access screens switch to the desktop card. */
export const ACCESS_DESKTOP_QUERY = '(min-width: 1024px)';

/** Primary action on desktop: 56px tall, 20px label. */
export const ACCESS_BUTTON_SIZE_DESKTOP: ButtonCustomSizeConfig = {
  height: 56,
  paddingX: 32,
  textType: 'p20',
  iconSize: 24,
};

/** Primary action below `lg`: 48px tall, 16px label. */
export const ACCESS_BUTTON_SIZE_MOBILE: ButtonCustomSizeConfig = {
  height: 48,
  paddingX: 24,
  textType: 'p16',
  iconSize: 20,
};

/** The primary-action size for the current viewport, updated on every breakpoint change. */
export function accessButtonSize$(
  breakpointObserver: BreakpointObserver,
): Observable<ButtonCustomSizeConfig> {
  return breakpointObserver
    .observe(ACCESS_DESKTOP_QUERY)
    .pipe(
      map(state =>
        state.matches ? ACCESS_BUTTON_SIZE_DESKTOP : ACCESS_BUTTON_SIZE_MOBILE,
      ),
    );
}
